import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import backgroundImage from '../../assets/Images/Login_background_Image.gif';
import vizLogo from '../../assets/Images/Vizlink_logo.png';
import { Col, Container, Image, Modal, Row } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikControl from '../../layouts/Input/FormikControl';
import { SendOtpToUserThroughEmail, VerifyOtpToUserThroughEmail, UpdateUserPassword } from './ForgetPasswordAction';
import { toast } from 'react-toastify'


const ForgetPassword = props => {
    const [currentScreen, setCurrentScreen] = useState('forgetPassword');
    const [forgetPasswordObject, setForgetPasswordObject] = useState({ email: '', oneTimePassword: '' });
    const [resetPasswordObject, setResetPasswordObject] = useState({ email: '', newPassword: '', confirmPassword: '', userId: '', token: '' });
    const [forgetPasswordState, setForgetPasswordState] = useState('notSendOtp');
    const [otpExpiry, setOtpExpiry] = useState(0);

    useEffect(() => {
        let timer = null;
        if (otpExpiry > 0) {
            timer = setInterval(() => {
                setOtpExpiry((prev) => prev - 1);
            }, 1000);
        }
        else {
            setForgetPasswordState('notSendOtp');
            setForgetPasswordObject({ ...forgetPasswordObject, oneTimePassword: '' })
        }
        return () => clearInterval(timer);
    }, [otpExpiry]);

    const forgetPasswordValidationSchema = Yup.object().shape
        ({
            email: Yup.string()
                .required('Email is required')
        });

    const resetPasswordValidationSchema = Yup.object().shape
        ({
            email: Yup.string()
                .required('Email is required'),
            newPassword: Yup.string()
                .required('Password is required')
                .min(8, 'Password must be at least 8 characters long')
                .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
                .matches(/[a-zA-Z0-9]/, 'Password must be alphanumeric')
                .matches(/[^a-zA-Z0-9]/, 'Password must contain at least one special character'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
                .required('Confirm Password is required')
        })

    const formatTime = (time) => {
        const minutes = String(Math.floor(time / 60)).padStart(2, '0');
        const seconds = String(time % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    const resetPasswordSubmit = async () => {
        var result = await props.UpdateUserPassword(resetPasswordObject);
        if (result.data.isSuccess) {
            setCurrentScreen('passwordUpdated');
        }
        else {
            toast.error(result.data.message);
        }

    }

    const forgetPasswordSubmit = async () => {
        if (forgetPasswordState == 'notSendOtp') {
            var result = await props.SendOtpToUserThroughEmail(forgetPasswordObject);
            if (result.data.isSuccess) {
                setForgetPasswordState('sentOtp');
                setOtpExpiry(result.data.response.expireTime);
                toast.success(result.data.message);
            }
            else {
                setForgetPasswordState('notSendOtp');
                toast.error(result.data.message);
            }
        }
        else {
            var result = await props.VerifyOtpToUserThroughEmail(forgetPasswordObject);
            if (result.data.isSuccess) {
                setResetPasswordObject({ ...resetPasswordObject, userId: result.data.response.userId, token: result.data.response.token, email: forgetPasswordObject.email });
                setCurrentScreen('resetPassword');
                toast.success(result.data.message);
            }
            else {
                toast.error(result.data.message);
            }
        }
    }

    return (
        <>
            <div
                className='login-page'
                style=
                {{
                    backgroundSize: 'cover',
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundRepeat: 'no-repeat',
                }}
            >
                <div className='login-box elevation-4'>
                    <div className='card-header text-center'>
                        <Link
                            className='brand-link clearfix'
                            to={'/login'}
                        >
                            <Image src={vizLogo} alt={'VizLink App Logo'} />
                        </Link>
                    </div>

                    {
                        currentScreen == 'forgetPassword' &&
                        <div>
                            <div className='card-body'>
                                <p className='login-box-msg text-bold'>
                                    {'Forgot Password'}
                                </p>
                            </div>

                            <Formik
                                enableReinitialize
                                validationSchema={forgetPasswordValidationSchema}
                                onSubmit={() => forgetPasswordSubmit()}
                                initialValues={forgetPasswordObject}
                            >
                                {
                                    (formik) =>
                                    (
                                        <Form autoComplete={'off'}>
                                            <Modal.Body>
                                                <Container>
                                                    <Row>
                                                        <Col xs={12} md={12}>
                                                            <div className='form-group'>
                                                                <FormikControl
                                                                    formik={formik}
                                                                    control='input'
                                                                    type='text'
                                                                    label='Email'
                                                                    name='email'
                                                                    value={forgetPasswordObject.email}
                                                                    handleOnChange={text => setForgetPasswordObject({ ...forgetPasswordObject, email: text })}
                                                                />
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={12}>
                                                            <div className='form-group'>
                                                                <FormikControl
                                                                    formik={formik}
                                                                    control='input'
                                                                    type='password'
                                                                    label='One Time Password'
                                                                    name='password'
                                                                    readOnly={forgetPasswordState == 'notSendOtp'}
                                                                    value={forgetPasswordObject.oneTimePassword}
                                                                    handleOnChange={text => setForgetPasswordObject({ ...forgetPasswordObject, oneTimePassword: text })}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row className='mt-3 mb-5'>
                                                        <input
                                                            className='btn btn-block btn-primary'
                                                            type='submit'
                                                            value={forgetPasswordState == 'notSendOtp' ? 'Send OTP' : 'Verify OTP'}
                                                        />
                                                        {
                                                            forgetPasswordState == 'sentOtp' &&
                                                            <div className='error invalid-field text-end '>{formatTime(otpExpiry)}</div>
                                                        }
                                                    </Row>
                                                </Container>
                                            </Modal.Body>
                                        </Form>
                                    )
                                }
                            </Formik>
                        </div>
                    }

                    {
                        currentScreen == 'resetPassword' &&
                        <div>
                            <div className='card-body'>
                                <p className='login-box-msg text-bold'>
                                    {'Reset your Password'}
                                </p>
                            </div>

                            <Formik
                                enableReinitialize
                                validationSchema={resetPasswordValidationSchema}
                                onSubmit={() => resetPasswordSubmit()}
                                initialValues={resetPasswordObject}
                            >
                                {
                                    (formik) =>
                                    (
                                        <Form autoComplete={'off'}>
                                            <Modal.Body>
                                                <Container>
                                                    <Row>
                                                        <Col xs={12} md={12}>
                                                            <div className='form-group'>
                                                                <FormikControl
                                                                    formik={formik}
                                                                    control='input'
                                                                    type='text'
                                                                    label='Email'
                                                                    name='email'
                                                                    value={resetPasswordObject.email}
                                                                    readOnly={true}
                                                                    handleOnChange={text => setResetPasswordObject({ ...resetPasswordObject, email: text })}
                                                                />
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={12}>
                                                            <div className='form-group'>
                                                                <FormikControl
                                                                    formik={formik}
                                                                    control='input'
                                                                    type='password'
                                                                    label='New Password'
                                                                    name='newPassword'
                                                                    value={resetPasswordObject.newPassword}
                                                                    handleOnChange={text => setResetPasswordObject({ ...resetPasswordObject, newPassword: text })}
                                                                />
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={12}>
                                                            <div className='form-group'>
                                                                <FormikControl
                                                                    formik={formik}
                                                                    control='input'
                                                                    type='password'
                                                                    label='Confirm New Password'
                                                                    name='confirmPassword'
                                                                    value={resetPasswordObject.confirmPassword}
                                                                    handleOnChange={text => setResetPasswordObject({ ...resetPasswordObject, confirmPassword: text })}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row className='mt-3 mb-5'>
                                                        <input
                                                            className='btn btn-block btn-primary'
                                                            type='submit'
                                                            value='Update Password'
                                                        />
                                                    </Row>
                                                </Container>
                                            </Modal.Body>
                                        </Form>
                                    )
                                }
                            </Formik>
                        </div>
                    }

                    {
                        currentScreen == 'passwordUpdated' &&
                        <div>
                            <div className='card-body'>
                                <p className='login-box-msg text-bold'>
                                    {'Password Updated successfully.'}
                                </p>
                                <p className='login-box-msg mt-5 mb-4'>
                                    {'Please login to your account'}
                                </p>
                                <Link className='btn btn-block btn-primary mb-5'
                                    to={'/login'} >
                                    Login
                                </Link>
                            </div>
                        </div>
                    }
                </div>

            </div>

        </>

    )
}

const mapStateToProps = (state) => {
    return {
    }
}

export default connect(mapStateToProps, { SendOtpToUserThroughEmail, VerifyOtpToUserThroughEmail, UpdateUserPassword })(ForgetPassword);